import React from "react";
import { CollapsibleFormSection } from "../../common/CollapsibleFormSection";
import { FormTextarea } from "../../common/FormTextarea";
import { SmartGoalSelector } from "../../common/SmartGoalSelector";
import { PersonalisedLearningSupportPlanData } from "src/models/form-types";

interface FormValidation {
  isPurposeValid: boolean;
  isLearningValid: boolean;
  isAdditionalInfoValid: boolean;
  isAdjustmentLevelValid: boolean;
  isStudentInfoValid: boolean;
}

interface NumeracyGoalSectionProps {
  formData: PersonalisedLearningSupportPlanData;
  onTextChange: (
    e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
  ) => void;
  goals: any[];
  isLoading: boolean;
  error: string | null;
  onGenerateGoals: () => Promise<void>;
  onGoalSelect: (goal: string) => void;
  selectedGoal: string | null;
  isFormValid: boolean;
  formValidation: FormValidation;
  className?: string;
}

export const NumeracyGoalSection: React.FC<NumeracyGoalSectionProps> = ({
  formData,
  onTextChange,
  goals,
  isLoading,
  error,
  onGenerateGoals,
  onGoalSelect,
  selectedGoal,
  isFormValid,
  formValidation,
  className,
}) => {
  return (
    <CollapsibleFormSection
      title="SMART Goal 2: Numeracy"
      className={className}
    >
      <FormTextarea
        id="numeracyGoalInfo"
        name="numeracyGoalInfo"
        label="Give me some information about the student's current numeracy level. This will help generate appropriate SMART goals."
        value={formData.numeracyGoalInfo}
        onChange={onTextChange}
        rows={4}
      />

      <SmartGoalSelector
        goals={goals.map((goal, index) => ({ id: index + 1, text: goal.text }))}
        isLoading={isLoading}
        error={error}
        onGenerateGoals={onGenerateGoals}
        onGoalSelect={onGoalSelect}
        isFormValid={isFormValid && formData.numeracyGoalInfo.trim() !== ""}
        formValidation={formValidation}
        invalidHintTitle="Please complete these required fields:"
        radioGroupName="numeracyGoals"
      />
    </CollapsibleFormSection>
  );
};
